import * as XLSX from "xlsx";

export default function CreateExcel(array: any) {
    let date = new Date();
    let wb = XLSX.utils.book_new();

    let sheet1: any[] = [];
    sheet1.push([
        "Produkt navn",
        "Artikkel nummer",
        "Antall",
        "Dato Bestilt",
    ]);

    array.forEach((item: any) => {
        const productName = item?.product?.name || "Unknown";
        const articleNumber = item?.product?.article_number || "Unknown";
        const amount = item?.amount || 0;

        let orderDate = "Invalid Date";
        if (item?.timestamp?.seconds !== undefined) {
            orderDate = new Date(
                item.timestamp.seconds * 1000 + (item.timestamp.nanoseconds || 0) / 1000000
            ).toLocaleDateString();
        }

        sheet1.push([productName, articleNumber, amount, orderDate]);
    });

    // Create worksheet
    let ws1 = XLSX.utils.aoa_to_sheet(sheet1);

    // Append sheets to workbook
    XLSX.utils.book_append_sheet(wb, ws1, "OrdreOversikt");

    // Generate Excel file as a Blob
    const wbout = XLSX.write(wb, { bookType: "xlsx", type: "array" });
    const blob = new Blob([wbout], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });

    // Generate file name
    const filename = `Ordreoversikt_${date.toLocaleDateString([], { day: '2-digit', month: '2-digit', year: '2-digit' })}_${date.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}.xlsx`;

    // Create a link element to trigger the file download
    const link = document.createElement("a");
    link.href = URL.createObjectURL(blob);
    link.download = filename;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link); // Clean up
}